import React, { useEffect, useRef } from 'react';

const BinaryBackground = ({ className = '' }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const mouse = { x: -1000, y: -1000 };

    const fontSize = 14;
    const radius = 300;
    const maxAlpha = 1;

    let widthCss = 0;
    let heightCss = 0;
    let columns = 0;
    let rows = 0;
    let animationFrameId = 0;

    const resize = () => {
      const dpr = Math.max(1, Math.min(2, window.devicePixelRatio || 1));
      widthCss = canvas.offsetWidth;
      heightCss = canvas.offsetHeight;

      canvas.width = Math.floor(widthCss * dpr);
      canvas.height = Math.floor(heightCss * dpr);

      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      columns = Math.ceil(widthCss / fontSize);
      rows = Math.ceil(heightCss / fontSize);
    };

    const handleMouseMove = (e) => {
      const rect = canvas.getBoundingClientRect();
      mouse.x = e.clientX - rect.left;
      mouse.y = e.clientY - rect.top;
    };

    const render = () => {
      ctx.clearRect(0, 0, widthCss, heightCss);
      ctx.font = `${fontSize}px monospace`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

      for (let i = 0; i < columns; i++) {
        for (let j = 0; j < rows; j++) {
          const x = i * fontSize + fontSize / 2;
          const y = j * fontSize + fontSize / 2;

          const dx = x - mouse.x;
          const dy = y - mouse.y;
          const dist = Math.sqrt(dx * dx + dy * dy);

          if (dist < radius) {
            const intensity = 1 - dist / radius;
            ctx.fillStyle = `rgba(151, 71, 255, ${intensity * maxAlpha})`;
            ctx.fillText(Math.random() > 0.5 ? '1' : '0', x, y);
            continue;
          }

          if ((i * j) % 23 === 0 && Math.random() > 0.99) {
            ctx.fillStyle = 'rgba(128, 128, 128, 0.12)';
            ctx.fillText(Math.random() > 0.5 ? '1' : '0', x, y);
          }
        }
      }

      animationFrameId = requestAnimationFrame(render);
    };

    resize();
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('resize', resize);
    animationFrameId = requestAnimationFrame(render);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('resize', resize);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      aria-hidden="true"
      className={className}
    />
  );
};

export default BinaryBackground;
